import { ThunkAction } from 'redux-thunk'
import { loadProfile } from '.'
import store, { RootState } from '..'
import { fuelStatisticApi } from '../../apis/fuelStatisticApi'
import { FuelStatisticEntity, FuelStatisticFilter } from '../../models'
import {
  FuelStatisticAction,
  SET_FUEL_STATISTIC,
  SET_FUEL_STATISTIC_FILTER,
  SET_FUEL_STATISTIC_LOADED,
} from '../types'

export const setFuelStatistic = (
  fuelStatistic: FuelStatisticEntity[]
): FuelStatisticAction => ({
  type: SET_FUEL_STATISTIC,
  payload: fuelStatistic,
})

export const setFuelStatisticLoaded = (
  loaded: boolean
): FuelStatisticAction => ({
  type: SET_FUEL_STATISTIC_LOADED,
  payload: loaded,
})

export const setFuelStatisticFilter = (
  filter: FuelStatisticFilter
): FuelStatisticAction => ({
  type: SET_FUEL_STATISTIC_FILTER,
  payload: {
    ...filter,
    startTime: new Date(
      new Date(filter.startTime).setHours(0, 0, 0, 0)
    ).getTime(),
    endTime: new Date(
      new Date(filter.endTime).setHours(23, 59, 59, 999)
    ).getTime(),
  },
})

export const loadFuelStatistic = (): ThunkAction<
  void,
  RootState,
  null,
  FuelStatisticAction
> => {
  return async (dispatch) => {
    try {
      const resp = await fuelStatisticApi.getFuelStatistic(
        store.getState().fuelStatistic.fuelStatisticFilter
      )
      dispatch(setFuelStatistic(resp.data.data))
    } catch (e) {
      if (e.response && e.response.status && e.response.status === 401) {
        dispatch(loadProfile())
        const resp = await fuelStatisticApi.getFuelStatistic(
          store.getState().fuelStatistic.fuelStatisticFilter
        )
        dispatch(setFuelStatistic(resp.data.data))
      }
    } finally {
      dispatch(setFuelStatisticLoaded(true))
    }
  }
}
